import { render } from "./HeroApp.vue?vue&type=template&id=435df205&scoped=true"
import script from "./HeroApp.vue?vue&type=script&lang=js"
export * from "./HeroApp.vue?vue&type=script&lang=js"

import "./HeroApp.vue?vue&type=style&index=0&id=435df205&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435df205"]])

export default __exports__